import React, { useEffect, useRef } from "react";
import {
  CustomLabel,
  ageConditionOfType,
  age_constant,
  age_constant_minus,
  gender_select_options,
  regex_obj,
  typeOfCal,
} from "../../Constant";
import CustomSelect from "../../elements/CustomSelect";
import { DatePicker, message } from "antd";
import moment from "moment/moment";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import InputComponent from "../InputComponent";

const AgePredict = (date) => {
  if (date == "") return "00";
  //
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  //

  date.split("/").reverse().join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  if (newDate === 0) {
    return `${moment().diff(new Date(new_date), "days")} days`;
  }
  // if (`${newDate}` == "NaN"){
  //   return "00"
  // }
  return newDate;
};

const DropdownCardContent = ({
  lable = "Adult",
  num = 0,
  p_data,
  onDataChange,
  user_data_info,
}) => {
  const [data, setData] = React.useState(p_data);
  const typeOfCalculator = useSelector((s) => s.common.type);

  useEffect(() => {
    // dataHandle()
  }, [data]);

  const dateAllowedForChild = (e) => {
    if (user_data_info.adult > 2 || user_data_info.child > 3 || user_data_info.adult === 0) {
      // if (user_data_info.adult > 2 || user_data_info.child > 3 || user_data_info.child === 1) {
      return (
        e &&
        (e.valueOf() < Date.now() - age_constant_minus["18"] ||
          e.valueOf() > Date.now() - age_constant_minus["91"])
      );
    } else if (
      typeOfCalculator === typeOfCal.prohealth ||
      typeOfCalculator === typeOfCal.superTopUp
    ) {
      return (
        e &&
        (e.valueOf() < Date.now() - age_constant_minus["23"] ||
          e.valueOf() > Date.now() - age_constant_minus["91"])
      );
    } else {
      return (
        e &&
        (e.valueOf() < Date.now() - age_constant_minus["26"] ||
          e.valueOf() > Date.now() - age_constant_minus["91"])
      );
    }
  };

  const datePermissible = () => {
    if (lable === "Adult") {
      if (typeOfCalculator === typeOfCal.primeSenior) {
        return moment(age_constant_minus["0"]).format("DD/MM/YYYY");
      }
      return moment(Date.now() - age_constant_minus["30"]).format("DD/MM/YYYY");
    } else {
      return moment(Date.now() - age_constant_minus["17"]).format("DD/MM/YYYY");
    }
  };

  const warning = () => {
    if (lable === "Adult" && AgePredict(data.dob) > 0) {
      return ageConditionOfType(
        typeOfCalculator,
        AgePredict(data.dob),
        user_data_info.adult
      );
      // return parseInt(AgePredict(data.dob)) > 65;
    }
  };

  const dataHandle = (type, e) => {
    if (type === "dob") {
      if (lable === "Adult") {
        onDataChange({ dob: e, gender: data.gender }, num - 1, "Adult", type);
      } else {
        onDataChange({ dob: e, gender: data.gender }, num - 1, "Child", type);
      }
    }

    if (type === "gender") {
      if (lable === "Adult") {
        onDataChange({ dob: data.dob, gender: e }, num - 1, "Adult", type);
      } else {
        onDataChange({ dob: data.dob, gender: e }, num - 1, "Child", type);
      }
    }
  };
  return (
    <div className="dob-detail-box">
      <CustomLabel font_size="12" color="#b2b2b2">
        {lable} 0{`${num}`} Age {data.dob}
      </CustomLabel>
      <div className="row">
        <div className="col-6">
          {data.dob == "" ? (
            <>
            {/* <DatePicker
              allowClear={true}
              defaultPickerValue={dayjs(datePermissible(), "DD/MM/YYYY")}
              placement={"bottom"}
              onChange={(_, e) => {
                setData({ ...data, dob: e });
                setTimeout(() => {
                  dataHandle("dob", e);
                }, 200);
              }}
              disabledDate={(e) => {
                if (lable === "Adult") {
                  return (
                    e && e.valueOf() > Date.now() - age_constant_minus["18"]
                  );
                } else {
                  return dateAllowedForChild(e);
                }
              }}
              showToday={false}
              format="DD/MM/YYYY"
            /> */}
            {/* <InputComponent
               maxAge = {lable === 'Adult' ? '90' :'26'}
               regex = {[([1-9])]}
              onChange={(e) => {
                let value = e.target.value
                setData({ ...data, dob: value });
               // dataHandle("dob", value)
                setTimeout(() => {
                  dataHandle("dob", value);
                }, 1000);
              }}
             // onBlur = {(e)=>dataHandle("dob", e.target.value)}
            /> */}

                      <InputComponent
                        regex={lable === "Adult" ? regex_obj.common : regex_obj.childAge}
                        placeholder="Enter Age"
                        value={data.dob}
                        onChange={async (e) => {
                          await setData({ ...data, dob: e.target.value });
                          setTimeout(()=>{
                            dataHandle("dob", e.target.value )
                          },1000) ;
                        }}
                        maxLength={2}
                        isAgeInput= {true}
                      />
            </>
          ) : (
            // <DatePicker
            //   // status={warning() && "error"}
            //   allowClear={true}
            //   value={dayjs(data.dob, "DD/MM/YYYY")}
            //   placement={"bottom"}
            //   onChange={(_, e) => {
            //     setData({ ...data, dob: e });
            //     setTimeout(() => {
            //       dataHandle("dob", e);
            //     }, 200);
            //   }}
            //   disabledDate={(e) => {
            //     if (lable === "Adult") {
            //       return (
            //         e && e.valueOf() > Date.now() - age_constant_minus["18"]
            //       );
            //     } else {
            //       return dateAllowedForChild(e);
            //     }
            //   }}
            //   showToday={false}
            //   format="DD/MM/YYYY"
            // />
            <>
                    <InputComponent
                        regex={lable === "Adult" ? regex_obj.common : regex_obj.childAge}
                        placeholder="Enter Age"
                        value={data.dob}
                        onChange={ (e) => {
                           setData({ ...data, dob: e.target.value });
                          setTimeout(()=>{
                            dataHandle("dob", e.target.value )
                          },1000) ;
                        }}
                        maxLength={2}
                        isAgeInput= {true}
                      />
            
            </>
          )}
        </div>
        <div className="col-6">
          <CustomSelect
            defaultValue={p_data.gender}
            options={gender_select_options}
            onChange={(e) => {
              setData({ ...data, gender: e.target.value });
              setTimeout(() => {
                dataHandle("gender", e.target.value);
              }, 200);
            }}
          />
        </div>
      </div>
      {false && (
        <span>
          <CustomLabel color="red" font_size="9">
            Age is not in permissible limit
          </CustomLabel>
        </span>
      )}
    </div>
  );
};

export default React.memo(DropdownCardContent);
